import { render, staticRenderFns } from "./appliedPotential.vue?vue&type=template&id=b471d9c2&scoped=true"
import script from "./appliedPotential.vue?vue&type=script&lang=js"
export * from "./appliedPotential.vue?vue&type=script&lang=js"
import style0 from "./appliedPotential.vue?vue&type=style&index=0&id=b471d9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b471d9c2",
  null
  
)

export default component.exports